import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import "antd/dist/antd.variable.min.css";
import App from "@/page/App";

const app = document.getElementById("root");

ReactDOM.render(<App />, app);
